import { render, staticRenderFns } from "./DashboardDecosummitAdCard.vue?vue&type=template&id=13d3005a&"
import script from "./DashboardDecosummitAdCard.vue?vue&type=script&lang=js&"
export * from "./DashboardDecosummitAdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports